import type { ViewSlug } from '~/types/components';
import type { SearchResult } from '~/types/models';
import type { ErrorResponse } from '~/types/responses';
import type { StringKeys } from '~/types/utils';

export interface IRestSlice<T, R extends string = StringKeys<T>> {
  columns: Record<ViewSlug, R[]>;
  data: T[];
  error: ErrorResponse | null;
  filters: Partial<Record<R, string | number | string[]>>;
  initialItem: string | null;
  item: T | null;
  loading: boolean;
  page: number;
  pageSize: number;
  sortBy: string;
  total: number | null;
  totalPages: number | null;
  with: string[];
}

export interface ISearchSlice {
  searchData: SearchResult[];
  searchLoading: boolean;
  searchQuery: string | null;
  searchTotal: number | null;
}

export interface INestedRestSlice<T> extends IRestSlice<T> {
  context: string;
}
export function isNestedRestSlice<T>(state: any): state is INestedRestSlice<T> {
  return !!state && typeof state.context === 'string';
}

export type IRestIndexParams<T> = Partial<{
  action: 'index' | 'retrieve' | 'import' | 'export' | 'create' | 'udpate' | 'delete' | 'stats';
  sortBy: string;
  page: number;
  pageSize: number;
  with: string;
}> & Partial<Record<StringKeys<T>, string | number | string[]>>;

export const restSliceMigrations = {
  0: (state: any): any => {
    return {
      state,
      columns: {
        index: [...state.columns],
        single: [...state.columns],
      },
    };
  },
};
